module.exports = __webpack_public_path__ + "img/icon4.3cc64631.png";